import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { AsyncValidatorFn, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../../dynamic-detail/dynamic-detail.component';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows:any = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    {name:"Tag Type",prop:"tagcategories_ids"},
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  
  public empAttendView: boolean[] = [];

  attendence_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  isVerified: boolean =false

  attendenceForm:FormGroup;

  selected_emp=null;
  emp_list=[]
  attendenceFormSubmitted:boolean=false;
  model={
      user: '',
      startTime: '10:00',
      endTime: '19:00',
      workingHours:'',
      attendanceDate: new Date(),
      notes: '',
      isVerified: '',
      task: '',
      status: '',
      admin_notes: '',
  }
  verified_list =[
    {name:'No',_id:'no'},
    {name:'Yes',_id:'yes'},
    {name:'In-review',_id:'inreview'},
  ]
  selected_verified=null
  startTime= new FormControl()
  endTime= new FormControl()
  s_time:any
  e_time:any
  timeDiff:any
  employee_badge_cat_id = '64b124832d735e2b98be9fd7'
  status_list=[]
  selected_status = null
  maxDate
  minDate
  emp_data:any
  start_date
  end_date
  current_date = new Date().toDateString();
  row_data:any
  status_count_data =[]
  guideline_data:any
 
  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,private formBuilder:FormBuilder) { 
                this.user_role=JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'My Attendance')
                this.guideline_data = key_data[0]?._id

                }

  ngOnInit(): void {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 6);
    this.minDate = sevenDaysAgo.toISOString().split('T')[0];
    this.maxDate = new Date().toISOString().split('T')[0];

    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    this.start_date = startDate.toISOString().split('T')[0];
    const endDate = new Date();
    this.end_date = endDate.toISOString().split('T')[0];

    this.getAttendenceByUser(this.user_role.id,this.start_date,this.end_date)
    this.getStatusList()

    this.attendenceForm=this.formBuilder.group({
      attendanceDate: ['', Validators.required],
      notes: ['', ],
      admin_notes: ['', ],
      task: ['',[Validators.required],[this.asyncTaskValidator()]]
    })
    this.startTime.valueChanges.subscribe((value) => {
      this.s_time = new Date(this.current_date+" "+value)
      this.getDiff(this.s_time,this.e_time)
    })
    this.endTime.valueChanges.subscribe((value) => {
      this.e_time = new Date(this.current_date+" "+value)
      this.getDiff(this.s_time,this.e_time)
    })
  }
  asyncTaskValidator(): AsyncValidatorFn {
    return (control) => {
      const value = control.value;

      return new Promise((resolve) => {
        // Simulate an asynchronous validation
        setTimeout(() => {
          if (value && value.trim().length < 20) {
            resolve({ 'notEnoughCharacters': true });
          } else {
            resolve(null); // Validation passed
          }
        }, 1000); // Simulate a delay of 1 second
      });
    };
  }
  getDiff(stime,etime){
    if(stime&&etime){
      const diffInMilliseconds = etime.getTime() - stime.getTime();
       const hours = Math.floor(diffInMilliseconds / 3600000);
       const minutes = Math.floor((diffInMilliseconds % 3600000) / 60000);
       this.timeDiff = `${hours} hours ${minutes} minutes`;
    }
 }
 getStartDate(event){
  this.start_date = event.target.value
  if(this.start_date > this.end_date){
    this.toastr.error('invalid date!')
  }
  else{
    if(this.start_date && this.end_date){
      this.getAttendenceByUser(this.user_role.id,this.start_date,this.end_date)
    }
  }
}
getEndDate(event){
  this.end_date = event.target.value
  if(this.start_date > this.end_date){
    this.toastr.error('invalid date!')
  }
  else{
    if(this.start_date && this.end_date){
      this.getAttendenceByUser(this.user_role.id,this.start_date,this.end_date)
    }
  }
}
filterAttendenceWithTwoDates(start_date,end_date){
  if(start_date && end_date){
    this.apiService.getCurrentEmpAttendanceFilter(this.user_role.id,start_date,end_date).subscribe((res:any)=>{
      this.rows = res?.data?.items[0]
    })
  }
  
}

  getAttendenceByUser(id,startDate,endDate){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAttendanceByUserId(id,1,100,startDate,endDate).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.items?.items
      this.status_count_data = res?.items?.statusCounts
      this.page.totalPages = res?.items?.totalCount
    })
  }
  pageChangeData(page:any){
    // this.apiService.getEmpAttendanceList(page.offset +1,page.pageSize).subscribe((res:any)=>{
    //   this.rows=res.data.items
    //   this.page.totalPages=res.data.totalCount
  
    // })
  }
  filterAttendence(data:any){
    if(data){
      this.apiService.getFilterEmpAttendance(this.user_role.id,data,this.start_date,this.end_date).subscribe((res:any)=>{
        this.rows=res?.data?.items
        this.status_count_data = res?.data?.statusCounts
        this.page.totalPages=res.data.totalCount
      })
    }
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.getAttendenceByUser(this.user_role.id,this.start_date , this.end_date )
  }
  editTag(id:any){
  }
  deleteAttendence(){
    if(this.attendence_id){
      this.apiService.deleteEmpAttendance(this.attendence_id).subscribe((res:any)=>{
        if(res.statusCode === 200){
          // this.getAllAttendence()
        }
        else{
          this.toastr.error(res.error)
        } 
        })
    }
    else{
      this.toastr.error('something went wrong !!')
    }
  }
   // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    this.attendence_id=id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteAttendence()      
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your imaginary file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  attendenceVerified(data){
    var id=data?._id
    this.isVerified = data?.isVerified;
    let model = {
      isVerified: this.isVerified ? false : true
    };
    this.apiService.updateEmpAttendance(id,model).subscribe((res: any) => {
      if (res.isSuccess === true) {
        this.toastr.success('Attendence verified successfull')
        // this.getAllAttendence()
      }
      else{
        this.toastr.error(res.error)
      }
    }) 
  }
  openModalAddNew(content){
    const modalRef = this.modalService.open(content);
    this.getEmpById(this.user_role.id)
    modalRef.result.then((result) => {
    this.attendenceForm.reset()

    }, (reason) => {
      this.attendenceForm.reset()

    });
  }
  getEmpById(id){
    this.apiService.getEmployeeById(id).subscribe((res:any)=>{
      this.emp_data = res?.data
    })
  }
  importTask(){
    this.model.task = this.emp_data.current_task
  }
  getStatusList(){
    this.apiService.getTagByTagCatgoryId(this.employee_badge_cat_id).subscribe((res:any)=>{
      this.status_list=res.data
      this.status_list = res.data.filter(item =>
        ["full-day", "short-leave", "half-day","paid-leave","unpaid-leave"].includes(item.name)
    );
    let status_idd = this.status_list.filter((item)=> ['full-day'].includes(item.name))
    this.selected_status = status_idd[0]?._id
    })
  }
  getStatusId(event){
    this.selected_status
  }
  submit(){
    let attendenceDate = moment(this.attendenceForm.value.attendanceDate).format('DD-MM-YYYY')
    let body ={
      user : this.selected_emp?this.selected_emp: this.user_role.id,
      startTime: this.startTime.value,  
      endTime: this.endTime.value,
      workingHours : this.timeDiff,
      attendanceDate: attendenceDate,
      notes: this.attendenceForm.value.notes,
      isVerified: 'no',
      task: this.attendenceForm.value.task,
      status : this.selected_status
    }
    if(!this.attendence_id){
      this.apiService.addEmpAttendance(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Add Attendance Successfully')
          this.modalService.dismissAll()
          this.getAttendenceByUser(this.user_role.id,'','')
        }
        else{this.toastr.error(res.error)}
      })
        this.attendenceFormSubmitted = true;
      if (this.attendenceForm.invalid) {
        return;
      }
    }
    // if(this.attendence_id){
    //   this.model.isVerified = this.selected_verified
    //   this.model.status = this.selected_status
    //   this.apiService.updateEmpAttendance(this.attendence_id,this.model).subscribe((res:any)=>{
    //     if(res.statusCode === 200){
    //       this.toastr.success('Add Attendance Successfully')
    //     // this.route.navigate(['/employees-attendence'])   
    //     window.history.back()   
    //     }
    //     else{this.toastr.error(res.error)}
    //   })
    // }

  }
  verifyAttendence(id){
    let body={
      isVerified: 'inreview',
    }
    this.apiService.updateEmpAttendance(id,body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('your attendence to in-review!')
        this.getAttendenceByUser(this.user_role.id,'','')
      }
      else this.toastr.error(res?.error)
    })
  }
  openModal2(content,data){
    this.row_data = data
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  mediumDate(date) {
    if (!date) return '';
  
    // Convert the input date to a Date object
    const dateObj = new Date(date);
  
    // Define months array for formatting
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
  
    // Extract date components
    const month = months[dateObj.getUTCMonth()];
    const dayOfMonth = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
  
    // Format the date in 'Jun 15, 2015' style
    return `${month} ${dayOfMonth}, ${year}`;
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }

}
